import { createStore } from "vuex";
import persistedStateVuex from "persisted-state-vuex";
import { tracker } from "@/main";

persistedStateVuex.config({
  storageKey: "integratedUserVuex",
});

const POPUP_STORAGE_KEY = "integratedPopupState";

const getDefaultPopupState = () => ({
  date: "",
  hiddenPopupKeys: [],
});

const loadPopupState = () => {
  if (typeof window === "undefined") {
    return getDefaultPopupState();
  }

  try {
    const directPopupState = JSON.parse(
      window.localStorage.getItem(POPUP_STORAGE_KEY) || "null",
    );

    if (directPopupState && typeof directPopupState === "object") {
      return {
        date: directPopupState.date || "",
        hiddenPopupKeys: Array.isArray(directPopupState.hiddenPopupKeys)
          ? directPopupState.hiddenPopupKeys
          : [],
      };
    }
  } catch (error) {
    console.error("loadPopupState error:", error);
  }

  return getDefaultPopupState();
};

const syncPopupStorage = (popupState) => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(
    POPUP_STORAGE_KEY,
    JSON.stringify(popupState),
  );
};

export default createStore({
  state: {
    spacType: [],
    headerInfo: {
      logoUrl: "",
      menulist: [],
    },
    footerInfo: {
      qaList: [],
    },
    countryIsoList: [],
    accessToken: "",
    userInfo: {},
    infoPopUp: loadPopupState(),
    companyInfo: {
      companyIdx: "",
      companyCode: "",
    },
    boardInfo: {},
    boardPluralInfo: {},
    applyInfo: {},
    itmSugangInfo: {
      pageIdx: -1,
      programIdx: -1,
      subjectIdx: -1,
      mainIdx: -1,
    },
    courseIdx: -1,
    itmApplyCompleteList: [],
    paymentInfo: {
      pgCodeType: "",
      selectSubjectList: [],
      paymentApplyInfo: {},
      merchantUid: "",
    },
    userFormInputLabel: [],
    ctmSugangInfo: {
      code: "",
    },
    ctmClassType: [],
    ctmStudentInfo: [],
    courseList: [],
    ctmApplyInfo: {},
    selectCourseItem: {},
    itmPageIdx: "",
    isWaitInfo: "",
    isFaq: "",
    isProxy: "",
    proxyInfo: {},
    proxyList: [],
  },
  getters: {
    /**
     * @description : SPAC TYPE(SPAC,SPAC-WRITING)
     */
    getSpacType(state) {
      return state.spacType;
    },
    /**
     * @description : Header에 들어갈 정보(logoUrl, menuList)
     */
    getHeaderInfo(state) {
      return state.headerInfo;
    },
    /**
     * @description : Footer에 들어갈 정보(qaList)
     */
    getFooterInfo(state) {
      return state.footerInfo;
    },
    /**
     * @description : ISO 리스트(countryIsoList)
     */
    getCountryIsoList(state) {
      return state.countryIsoList;
    },
    /**
     * @description : 사용자 정보(getAccessToken)
     */
    getAccessToken(state) {
      return state.accessToken;
    },
    /**
     * @description : 팝업(getInfoPopUp)
     */
    getInfoPopUp(state) {
      return state.infoPopUp;
    },
    /**
     * @description : 사용자 정보(getUserInfo)
     */
    getUserInfo(state) {
      return state.userInfo;
    },
    /**
     * @description : 회사코드(getCompanyCode)
     */
    getCompanyInfo(state) {
      return state.companyInfo;
    },
    /**
     *
     * @description : Notice 정보
     */
    getBoardInfo(state) {
      return state.boardInfo;
    },
    /**
     * @description : 복수과정 Notice 정보
     */
    getBoardPluralInfo(state) {
      return state.boardPluralInfo;
    },
    /**
     * @description : ApplyInfo 정보
     */
    getApplyInfo(state) {
      return state.applyInfo;
    },
    /**
     * @description : ItmSugangInfo 정보
     */
    getItmSugangInfo(state) {
      return state.itmSugangInfo;
    },
    /**
     * @description : courseIdx 정보
     */
    getCourseIdx(state) {
      return state.courseIdx;
    },
    /**
     * @description : ITM 신청 수강신청 내역
     */
    getItmApplyCompleteList(state) {
      return state.itmApplyCompleteList;
    },
    /**
     * @description : 결제 정보
     */
    getPaymentInfo(state) {
      return state.paymentInfo;
    },
    /**
     * @description : 입력폼 리스트
     */
    getUserFormInputLabel(state) {
      return state.userFormInputLabel;
    },
    /**
     * @description : ctm 수강 정보
     */
    getCtmSugangInfo(state) {
      return state.ctmSugangInfo;
    },
    /**
     * @description : ctm 수업 유형 선택
     */
    getCtmClassType(state) {
      return state.ctmClassType;
    },
    /**
     * @description : ctm 항목 정보
     */
    getCtmStudentInfo(state) {
      return state.ctmStudentInfo;
    },
    /**
     * @description : 통합수강신청 코스 리스트
     */
    getCourseList(state) {
      return state.courseList;
    },
    /**
     * @description : 통합수강신청 전화영어 신청 정보
     */
    getCtmApplyInfo(state) {
      return state.ctmApplyInfo;
    },
    /**
     * @description : 선택된 코스
     */
    getSelectCourseItem(state) {
      return state.selectCourseItem;
    },
    /**
     * @description : itm PageIdx
     */
    getItmPageIdx(state) {
      return state.itmPageIdx;
    },
    getisWaitInfo(state) {
      return state.isWaitInfo;
    },
    getisFaq(state) {
      return state.isFaq;
    },
    getProxyInfo(state) {
      return state.proxyInfo;
    },
    getProxyList(state) {
      return state.proxyList;
    },
  },
  mutations: {
    setSpacType(state, payload) {
      state.spacType = payload;
    },
    setHeaderInfo(state, payload) {
      state.headerInfo = payload;
    },
    setFooterInfo(state, payload) {
      state.footerInfo = payload;
    },
    setCountryIsoList(state, payload) {
      state.countryIsoList = payload;
    },
    setAccessToken(state, payload) {
      state.accessToken = payload;
    },
    setUserInfo(state, payload) {
      state.userInfo = payload;
      tracker.setUserID(payload.userName);
    },
    setInfoPopUp(state, payload) {
      const { date, popupKey } = payload || {};

      if (!date || popupKey === undefined || popupKey === null) {
        state.infoPopUp = getDefaultPopupState();
        syncPopupStorage(state.infoPopUp);
        return;
      }

      if (state.infoPopUp?.date !== date) {
        state.infoPopUp = {
          date,
          hiddenPopupKeys: [popupKey],
        };
        syncPopupStorage(state.infoPopUp);
        return;
      }

      const hiddenPopupKeys = Array.isArray(state.infoPopUp.hiddenPopupKeys)
        ? state.infoPopUp.hiddenPopupKeys
        : [];

      if (!hiddenPopupKeys.includes(popupKey)) {
        hiddenPopupKeys.push(popupKey);
      }

      state.infoPopUp = {
        date,
        hiddenPopupKeys,
      };
      syncPopupStorage(state.infoPopUp);
    },
    setCompanyInfo(state, payload) {
      state.companyInfo = payload;
    },
    setBoardInfo(state, payload) {
      state.boardInfo = payload;
    },
    setBoardPluralInfo(state, payload) {
      state.boardPluralInfo = payload;
    },
    setApplyInfo(state, payload) {
      state.applyInfo = payload;
    },
    setItmSugangInfo(state, payload) {
      state.itmSugangInfo = payload;
    },
    setCourseIdx(state, payload) {
      state.courseIdx = payload;
    },
    setItmApplyCompleteList(state, payload) {
      state.itmApplyCompleteList = payload;
    },
    setPaymentInfo(state, payload) {
      state.paymentInfo = payload;
    },
    setUserFormInputLabel(state, payload) {
      state.userFormInputLabel = payload;
    },
    setCtmSugangInfo(state, payload) {
      state.ctmSugangInfo = payload;
    },
    setCtmClassType(state, payload) {
      state.ctmClassType = payload;
    },
    setCtmStudentInfo(state, payload) {
      state.ctmStudentInfo = payload;
    },
    setCourseList(state, payload) {
      state.courseList = payload;
    },
    setCtmApplyInfo(state, payload) {
      state.ctmApplyInfo = payload;
    },
    setSelectCourseItem(state, payload) {
      state.selectCourseItem = payload;
    },
    setItmPageIdx(state, payload) {
      state.itmPageIdx = payload;
    },
    setWaitInfo(state, payload) {
      state.isWaitInfo = payload;
    },
    setisFaq(state, payload) {
      state.isFaq = payload;
    },
    setisProxy(state, payload) {
      state.isProxy = payload;
    },
    // 대리인 상세 정보 저장 (userform에서 저장 후 신청 완료 시 registerProxy 호출에 사용)
    setProxyInfo(state, payload) {
      state.proxyInfo = payload;
    },
    setProxyList(state, payload) {
      state.proxyList = payload;
    },
  },
  actions: {},
  plugins: [persistedStateVuex.init],
});
